module.exports = __webpack_public_path__ + "static/media/link-blu.c9a25528.svg";